import {
    Button,
    CssBaseline,
    makeStyles,
    TextField,
    Typography,
    IconButton,
    Box,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {
    member as v_member,
    basic,
    Values,
    oper as v_oper,
} from '../request/values';

import React, { Fragment, useState } from 'react';
import { COLORS } from './Theme';

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';
import { TitleBackBar } from './header/TitleBar';
import DialogConfirm, { DialogInput, DialogInputText2 } from './Dialog';
import { useCookies } from 'react-cookie';
import AudioPlayer from './AudioPlayer';

const useStyles = makeStyles((theme) => ({
    box: {
        marginTop: '5vh',
    },
    button: {
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.16)',
        borderRadius: 24,
        width: '80vw',
        height: '6vh',
        marginBottom: '2.5vh',
        paddingLeft: '8vw',

        justifyContent: 'start',

        '& img': {
            marginRight: '4vw',
        },
        '& p': {
            color: `${COLORS.BROWNISH_GREY}`,
            fontSize: '4vw',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
        [theme.breakpoints.up("md")]: {
          width: '550px',
        },  
    },

    logoSection: {
        display: 'flex',
        flex: 1,
        width: '100%',
        alignItems: 'flex-end',
        paddingBottom: '5vh',
    },
    logo: {
        width: '5.5vw',
        maxWidth: '30px'
    },
    deleteAccountButton: {
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.16)',
        borderRadius: 24,

        width: '20vw',
        height: '3vh',
        marginBottom: '2.5vh',

        alignContent: 'left',
        '& img': {
            marginRight: '4vw',
        },
        '& p': {
            color: `${COLORS.BROWNISH_GREY}`,
            fontSize: '0.7rem',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
        [theme.breakpoints.up("md")]: {
          width: '30%',
          height: '4vh',
          '& p': {
            color: `${COLORS.BROWNISH_GREY}`,
            fontSize: '14px',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
        }
    },
    footer: {
      textAlign: 'center', 
      marginLeft: 'auto', 
      position: 'fixed',
      bottom: theme.spacing(3),
      boxSizing: "border-box",
      left: "0",
      right: "0",
    },
    deleteWrapper: {
      textAlign: 'right',
      marginRight: '3vw',
      paddingBottom: '1vh',
      [theme.breakpoints.up("md")]: {
        marginRight: '0',
      }
    }
}));

const SERVER = basic.server;

const Setting: React.FC<any> = (props) => {
    const classes = useStyles();
    let history = useHistory();

    const { member, setMember, deleteMember } = props;
    const [cookies, setCookie, removeCookie] = useCookies();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [input, setInput] = useState<boolean>(false);
    const [logoutDialog, setLogoutDialog] = useState<boolean>(false);
    const [deleteAccountDialog, setDeleteAccountDialog] =
        useState<boolean>(false);
    const [confirm, setConfirm] = useState<string>('');

    const action = (key: any) => (
        <Fragment>
            <Button
                onClick={() => {
                    closeSnackbar(key);
                }}
            >
                Close
            </Button>
        </Fragment>
    );

    const handleClose = (key: string) => {
        if (key === 'input') setInput((prevState) => !prevState);
        else if (key === 'confirm') setConfirm((prevState) => '');
        else if (key === 'logout') {
            setLogoutDialog((prevState) => !prevState);
        } else if (key === 'deleteAccount') {
            setDeleteAccountDialog((prevState) => !prevState);
        }
    };

    const handleInputOpen = () => {
        setInput(true);
    };

    const handleLogoutOpen = () => {
        setLogoutDialog(true);
    };

    const handleDeleteMemberOpen = () => {
        setDeleteAccountDialog(true);
    };

    const handleRanking = () => {
        history.push({
            pathname: '/operation/ClassRun',
            state: {
                // location state
                code: member.classCode,
            },
        });
    };

    const handleConfirmOpen = (classCode: string) => {
        if (classCode !== '') {
            setConfirm(classCode);
            setInput(false);
        }
    };

    const logout = () => {
        const options = {
            path: process.env.COOKIE_PATH,
            domain: process.env.COOKIE_DOMAIN || '.playstartup.net', // 도메인 설정
        };
        removeCookie('access', options);
        removeCookie('access');
        console.log('options? ', options);
        deleteMember();
        history.push('/');
    };

    const goDeleteAccount = () => {
        history.push('/deleteUserAccount');
    };

    const postChangeClass = () => {
        let url;
        let data;
        if (member.type === 'member') {
            url = SERVER + v_member.member + v_member.class_exit;
            data = {
                classCode: member.classCode,
                companyNum: member.companyNum,
                email: member.id,
                changeCode: confirm,
            };
        } else if (member.type === 'oper') {
            url = SERVER + v_oper.oper + v_oper.class_enter;
            data = {
                classCode: confirm,
                email: member.id,
            };
        }

        axios({
            method: 'POST',
            data: data,
            withCredentials: true,
            url: url,
        })
            .then((res) => res.data)
            .then((data: any) => {
                if (data.code == Values.SUCCESS_CODE) {
                    if (member.type === 'member') {
                        setMember(
                            Object.assign({}, member, {
                                companyNum: 0,
                                classCode: confirm,
                                classVersion: data.class_version,
                            })
                        );
                    } else if (member.type === 'oper') {
                        setMember(
                            Object.assign({}, member, {
                                classCode: confirm,
                                classVersion: data.class_version,
                            })
                        );
                    }

                    history.push('/');
                } else if (data.code == Values.CLASS_NO_START_CODE) {
                    enqueueSnackbar(ToastStr.CLASS_NO_START_STR, {
                        variant: 'warning',
                        translate: 'no',
                    });
                } else if (data.code == Values.CLASS_FINISH_CODE) {
                    enqueueSnackbar(ToastStr.CLASS_FINISH_STR, {
                        variant: 'warning',
                        translate: 'no',
                    });
                } else if (data.code == Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.CLASS_ENTER_FAIL, {
                        variant: 'warning',
                        translate: 'no',
                    });
                } else {
                    enqueueSnackbar(ToastStr.CLASS_ENTER_FAIL, {
                        variant: 'error',
                        translate: 'no',
                    });
                }
                handleClose('confirm');
            });
    };

    return (
        <div>
            <TitleBackBar
                history={history}
                title="설정하기"
                titleIcon="setting"
            />

            <Box
                className={classes.box}
                display="grid"
                justifyContent="center"
                alignItems="center"
            >
                <Button
                    onClick={() => handleInputOpen()}
                    className={classes.button}
                >
                    <img src="/images/refresh.webp" style={{ width: '2rem' }} />
                    <Typography style={{ fontSize: '1rem' }}>
                        클래스 코드 변경하기
                    </Typography>
                </Button>
                <Button
                    onClick={() => handleLogoutOpen()}
                    className={classes.button}
                >
                    <img src="/images/logout.webp" style={{ width: '2rem' }} />
                    <Typography style={{ fontSize: '1rem' }}>
                        로그아웃
                    </Typography>
                </Button>
                {member.type == 'oper' && (
                    <Button
                        onClick={() => handleRanking()}
                        className={classes.button}
                    >
                        <img
                            src="/images/ranking/gold.webp"
                            style={{ width: '2rem' }}
                        />
                        <Typography style={{ fontSize: '1rem' }}>
                            랭킹 페이지
                        </Typography>
                    </Button>
                )}
            </Box>

            <div className={classes.logoSection}>
                <div style={{ flexDirection: 'column', width: '100vw' }}>
                    <div className={classes.deleteWrapper}>
                        <Button
                            onClick={() => handleDeleteMemberOpen()}
                            className={classes.deleteAccountButton}
                        >
                            <Typography>
                                계정 삭제
                            </Typography>
                        </Button>
                    </div>
                    <div className={classes.footer}>
                        <img className={classes.logo} src="/images/p.webp" />
                    </div>
                </div>
            </div>

            <DialogInputText2
                open={input}
                inputType={'text'}
                handleClose={() => handleClose('input')}
                title="변경할 클래스 코드를 입력해주세요."
                yesConfirm={(e: any, classCode: string) =>
                    handleConfirmOpen(classCode)
                }
                noConfirm={() => handleClose('input')}
            />
            <DialogConfirm
                open={confirm === '' ? false : true}
                handleClose={() => handleClose('confirm')}
                title={'수정할 클래스 코드를 확인해주세요.'}
                context={confirm}
                yesConfirm={() => postChangeClass()}
                noConfirm={() => handleClose('confirm')}
            />
            <DialogConfirm
                open={logoutDialog}
                handleClose={() => handleClose('logout')}
                title={'로그아웃 하시겠습니까?'}
                context={''}
                yesText="네"
                noText="아니오"
                yesConfirm={() => logout()}
                noConfirm={() => handleClose('logout')}
            />
            <DialogConfirm
                open={deleteAccountDialog}
                handleClose={() => handleClose('deleteAccount')}
                title={'계정 삭제 페이지로 이동하시겠습니까?'}
                context={''}
                yesText="네"
                noText="아니오"
                yesConfirm={() => goDeleteAccount()}
                noConfirm={() => handleClose('deleteAccount')}
            />
        </div>
    );
};

export default Setting;
